module.exports = __webpack_public_path__ + "static/img/winner3.3ad5edc1.png";